import React from 'react'
import { Link as RouterLink } from 'react-router-dom';
import { withRouter } from 'react-router-dom'
import {
  Link
} from '@material-ui/core'
import './VinstriLinkar.scss'
import VinstriLinkur from './VinstriLinkur/VinstriLinkur'
import { useMediaQuery } from 'react-responsive'


function VinstriLinkar(props) {
  const {
    header,
    history,
    prismicCtx,
    form
  } = props

  const isMobile = useMediaQuery({ query: '(max-width: 1300px)' })

  function handleClick() {
    history.push('/')
  }

  if (isMobile || form) {
    return (
      <div style={{ width: '40vw', display: 'flex', height: '100%', alignItems: 'center', marginLeft: 20 }}>
        {/* <Link 
          
          style={{
            fontSize:'20px',
            textDecoration: 'none',
            color: 'black'
            }}>
          {header.data.vinstri_linkur_titill[0].text}
        </Link> */}
        {/* <img onClick={handleClick} className='vinstriLinkur_mynd' src='https://res.cloudinary.com/ispan/image/upload/v1570224522/ispanlogo_boxpcc.png' */}
        <img onClick={handleClick} className='vinstriLinkur_mynd' src='https://res.cloudinary.com/ispan/image/upload/v1613399747/Untitled-1_tpzlln.png'
          style={{ height: '90%', marginRight: 10 }} alt="Heim" />
      </div>
    )
  } else {
    return (
      <div>
        <div style={{ width: '40vw', display: 'flex', height: '100%', alignItems: 'center', marginLeft: 20 }}>
          {/* <Link 
          
          style={{
            fontSize:'20px',
            textDecoration: 'none',
            color: 'black'
            }}>
          {header.data.vinstri_linkur_titill[0].text}
        </Link> */}
          <img onClick={handleClick} className='vinstriLinkur_mynd' src='https://res.cloudinary.com/ispan/image/upload/v1613399747/Untitled-1_tpzlln.png'
            style={{ height: '90%', marginRight: 10 }} alt="Heim"/>

          {header.data.vinstri_linkar.map((linkur, i) => (
            <VinstriLinkur
              key={i}
              linkur={linkur}
              prismicCtx={prismicCtx}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default withRouter(VinstriLinkar);